/**
 * This mixin exposes string replacement methods
 */

export default {
  methods: {
    /**
     * This method converts an arbitrary string to kebab case.
     * Input: Some String
     * Output: some-string
     */
    stringToKebabCase(string) {
      return string
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
    },
  },
};
